<template>
  <v-container>
    <v-card elevation="2">
      <v-card-title style="background-color: dimgrey;">
        <img src="@/assets/logo_nuevo.png" style="width:40px;height:41px">
        <span class="headline ml-7" style="color: white;">
          <b>BUZÓN ELECTRÓNICO - VERIFICAR CUENTA</b>
        </span>
      </v-card-title>

    </v-card>
    <v-dialog
      elevation="20"
      hide-overlay
      v-model="dialog"
      persistent
      width="400"
    >
      <v-card dark style="padding-top: 19px; background-color: dimgrey;" class="text-center">
        <v-card-text>
          <b style="color: floralwhite;">Validando correo electrónico...</b>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-3 mt-3"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        dialog: true
      }
    },
    mounted(){
      if (this.$route.query.token) {
        setTimeout(function () {
          this.verificar()
        }.bind(this), 2000);
      }
    },
    methods:{
      verificar() {
        this.$store.dispatch("VERIFICAR", { url:"/user/verify", data:this.$route.query } ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Correo verificado con éxito, Favor de iniciar sesión en el sistema.',
            confirmButtonText: "Aceptar"
          })
          this.$router.push({name: 'Login'});
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: error.response.data.message,
            confirmButtonText: "Aceptar"
          })
          this.$router.push({name: 'Login'});
        });
      }
    }
  }
</script>
